// 结算标准
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane label="批量" name="zero">

        <batchView v-if="showEdit2" visible-key="showEdit2" :_dataId.sync="dataId2" :parent-target="_self"
                   @reload="$reloadHandle" @editViewDataUpdate="editViewDataUpdate"></batchView>
      </el-tab-pane>

      <el-tab-pane label="常规1" name="first">
        <editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :parent-target="_self"
                  @reload="$reloadHandle" @editViewDataUpdate="editViewDataUpdate"></editView>
      </el-tab-pane>
      <el-tab-pane label="列表" name="second">
        <div class="grid-height" style="height: calc(100vh - -65px)!important;">
          <vxe-grid show-overflow height="100%" :stripe="true" border="default" :row-config="{ isHover: true }"
                    ref="table-m1" v-bind="vxeOption"
                    @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle">

            <template #form>
              <div class="clearfix screen-btns">
                <div class="fl">
                  <vxe-button status="primary" class="button-sty" icon="el-icon-plus"
                              @click="openEditDialog">新增1
                  </vxe-button>
                  <vxe-button status="primary" class="button-sty" icon="el-icon-plus"
                              @click="openEditDialog2">批量新增
                  </vxe-button>
                  <vxe-button status="primary" class="button-sty" icon="el-icon-plus"
                              @click="openEditDialog">批量导入
                  </vxe-button>
                </div>
                <div class="fr">
                  <!--                  <vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text"-->
                  <!--                              status="primary" plain>重置-->
                  <!--                  </vxe-button>-->
                  <vxe-button status="warning" icon="el-icon-search" class="button-sty"
                              @click="searchEvent">搜索
                  </vxe-button>
                </div>
              </div>
              <vxe-form ref="form" class="screen-box" title-width="92px" title-align="right" :data="formData"
                        @submit="searchEvent" @reset="searchEvent">
                <vxe-form-item title="标准名称:" field="code">
                  <template v-slot>
                    <el-input v-model="formData.name" size="small" clearable/>
                  </template>
                </vxe-form-item>
                <vxe-form-item title="品牌:" field="code">
                  <template v-slot>
                    <el-select v-model="formData.brandId" placeholder="请选择品牌"
                               clearable>
                      <el-option v-for="item in brandOptions" :key="item.value" :label="item.label"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </template>
                </vxe-form-item>

                <vxe-form-item title="产品名称:" field="code">
                  <template v-slot>
                    <el-input v-model="formData.itemName" size="small" clearable/>
                  </template>
                </vxe-form-item>
                <vxe-form-item title="服务类型:" field="name">
                  <template v-slot>
                    <el-select v-model="formData.bigCategoryId" placeholder="产品大类" @change='productSelectOne'

                               style="width: 49%!important;">
                      <el-option v-for="item in productOptions0" :key="item.value" :label="item.label"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                    <el-select v-model="formData.smallCategoryId" placeholder="产品小类" clearable
                               style="width: 49%!important;margin-left:2%;">
                      <el-option v-for="item in productOptions1" :key="item.value" :label="item.label"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </template>
                </vxe-form-item>
                <vxe-form-item title="网点名称:" field="name">
                  <template v-slot>
                    <el-autocomplete
                      class="inline-input"
                      v-model="siteName"
                      :fetch-suggestions="querySiteSearch"
                      placeholder=""
                      :trigger-on-focus="false"
                      @select="handleSiteSelect"
                    ></el-autocomplete>
                  </template>
                </vxe-form-item>

                <vxe-form-item title="状态:" field="code">
                  <template v-slot>
                    <el-select v-model="formData.stat">
                      <el-option label="全部" :value="null"/>
                      <el-option label="未生效" :value="0"/>
                      <el-option label="生效" :value="1"/>
                      <el-option label="做废" :value="9"/>
                    </el-select>
                  </template>
                </vxe-form-item>
                <vxe-form-item title="结算等级:" field="code">
                  <template v-slot>
                    <el-select v-model="formData.settleLevel">
                      <el-option label="全部" :value="null"/>
                      <el-option label="默认" :value="0"/>
                      <el-option label="一级" :value="1"/>
                      <el-option label="二级" :value="2"/>
                      <el-option label="三级" :value="3"/>
                      <el-option label="四级" :value="4"/>
                    </el-select>
                  </template>
                </vxe-form-item>

                <vxe-form-item title="有效时间:" field="time">
                  <template v-slot>
                    <el-date-picker style="width: 20vw; height: 36px;"
                                    v-model="formData.date"
                                    type="daterange"
                                    align="right"
                                    unlink-panels
                                    range-separator="-"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    :picker-options="pickerOptions"
                                    value-format='yyyy-MM-dd'>
                    </el-date-picker>
                  </template>
                </vxe-form-item>
              </vxe-form>
            </template>
            <template #pager>
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>
          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import editView from './edit.vue';
import batchView from './batch.vue';
import {initVxeTable} from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import {fetchTree} from "@/api/admin/type_tree"
import api from "@/api/projectApi";

export default {
  components: {editView, pager, batchView},
  data() {
    return {
      total: 0,
      getListPageUrl: '/basic/sfSettleStandard/getListPage',
      editViewDataUpdateFlag: false,
      activeName: 'second',
      dataId: 0,
      dataId2: 0,

      showEdit: false,
      showEdit2: false,

      vxeOption: {},
      // 查询参数
      requestParam: {
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量
        bigCategoryId: '',
        smallCategoryId: '',
        name: '',
        beginDate: '',
        endDate: '',
        siteId: null,
        itemName: null,
        settleLevel: null,
        stat: null,
        brandId: null,
        date: null,
      },
      formData: {
        bigCategoryId: '',
        smallCategoryId: '',
        name: '',
        beginDate: '',
        endDate: '',
        siteId: null,
        itemName: null,
        settleLevel: null,
        stat: null,
        brandId: null,
        date: null,
      },
      siteName: null,
      brandOptions: [],
      productOptions0: [],
      productOptions1: [],
      itemLits: [],
      pageSizes: [10, 20, 100],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      columns: [
        {type: 'seq', width: 60, title: '序号', resizable: false, fixed: 'left'},
        {title: '标准名称', field: 'name', width: 100,},
        {title: '服务类型', field: 'serviceTypeName', width: 100,},
        {title: '品牌', field: 'brandName', width: 70,},
        {
          title: '保修类型', field: 'guaranteeType', width: 80, slots: {
            default: ({row}) => {
              if (row.guaranteeType == 1) {
                return [
                  <div>
                    <span>保内</span>
                  </div>
                ];
              } else if (row.guaranteeType == 2) {
                return [
                  <div>
                    <span>保外</span>
                  </div>
                ];
              }
            }
          }
        },
        {title: '产品大类', field: 'bigCategoryName', width: 110,},
        {title: '产品小类', field: 'smallCategoryName', width: 110,},
        {title: '产品', field: 'itemName', width: 110,},
        {title: '开始时间', field: 'beginDate', width: 100,},
        {title: '结束时间', field: 'endDate', width: 100,},
        {title: '网点', field: 'siteName', width: 100,},
        {title: '网点等级', field: 'siteLevelName', width: 150,},
        {
          title: '区域结算等级', field: 'settleLevel', width: 110, slots: {
            default: ({row}) => {
              if (row.settleLevel == 0) {
                return [
                  <div>
                    <span>默认</span>
                  </div>
                ];
              } else if (row.settleLevel == 1) {
                return [
                  <div>
                    <span>一级</span>
                  </div>
                ];
              } else if (row.settleLevel == 2) {
                return [
                  <div>
                    <span>二级</span>
                  </div>
                ];
              } else if (row.settleLevel == 3) {
                return [
                  <div>
                    <span>三级</span>
                  </div>
                ];
              } else if (row.settleLevel == 4) {
                return [
                  <div>
                    <span>四级</span>
                  </div>
                ];
              }
            }
          }
        },
        {title: '服务费', field: 'price', width: 80,},
        {
          title: '状态', field: 'stat', width: 90, slots: {
            default: ({row}) => {
              if (row.stat == 0) {
                return [
                  <div class="txt-status disable">
                    <span>未生效</span>
                  </div>
                ];
              } else if (row.stat == 1) {
                return [
                  <div class="txt-status">
                    <span>生效</span>
                  </div>
                ];
              } else if (row.stat == 9) {
                return [
                  <div class="txt-status disable">
                    <span>做废</span>
                  </div>
                ];
              }
            }
          }
        },
        {field: 'createTime', title: '创建时间', width: 150},
        {title: '创建人', field: 'createBy', width: 150,},
        {
          width: 80, fixed: 'right', title: '', sortable: false, slots: {
            default: ({row}) => {
              return [
                <div>
                  <a
                    href="javascript:void(0);"
                    class="a-link"
                    onclick={() => {
                      this.openEditDialog(row.id);
                    }}
                  >
                    <el-tooltip enterable={false} effect="dark" content="查看" placement="top"
                                popper-class="tooltip-skin">
                      <i class="el-icon-edit"/>
                    </el-tooltip>
                  </a>
                  <a
                    href="javascript:void(0);"
                    class="a-link"
                    onclick={() => {
                      this.delect(row.id);
                    }}
                  >
                    <el-tooltip enterable={false} effect="dark" content="删除" placement="top"
                                popper-class="tooltip-skin">

                      <i class="el-icon-delete"/>
                    </el-tooltip>
                  </a>
                </div>
              ];
            }
          }
        }
      ]
    }
  },
  mounted() {
    this.loadProductOption0()
    this.loadBrandOption()
  },
  watch: {
    activeName(newVal) {
      if (newVal === 'second' && this.editViewDataUpdateFlag) {
        this.getTableData()
      }
    },
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
    siteName(n) {
      if (!n) {
        this.formData.siteId = null
      }
    },
    'formData.date': {
      handler(n) {
        if (n != null && n.length > 0) {
          this.formData.beginDate = n[0]
          this.formData.endDate = n[1]
        }
      },
      deep: true
    }
  },
  methods: {


    // 服务商提示选中
    handleSiteSelect(data) {
      console.log('selectData', data)
      this.formData.siteId = data.id
    },

    // 获取服务商提示
    querySiteSearch(queryStr, callback) {
      this.$http({
        url: api.snUser.getPromptDataUrl,
        method: 'post',
        data: {userName: queryStr}
      }).then(res => {
        console.log(res.data.data, '网点提示内容')
        let temp = []
        res.data.data.forEach(item => {
          temp.push({value: item.userName, id: item.id})
        })
        callback(temp)
      })
    },


    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    // 加载table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: this.getListPageUrl,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData();
    },

    // 加载产品大类
    loadProductOption0() {
      fetchTree({
        categoryType: 1,  // 产品
        // usable: 1  // 加载启用的
      }).then(response => {
        this.productOptions0 = []
        response.data.data.forEach(item => {
          this.productOptions0.push({
            label: item.categoryName,
            value: item.id
          })
        })
      })
    },

    // 加载产品小类
    loadProductOption1() {
      if (this.formData.bigCategoryId === ''
        || this.formData.bigCategoryId === null
        || this.formData.bigCategoryId === undefined) {
        this.productOptions1 = []
      } else {
        fetchTree({
          categoryType: 1,  // 产品
          // usable: 1,  // 加载启用的
          parentId: this.formData.bigCategoryId
        }).then(response => {
          this.productOptions1 = []
          response.data.data.forEach(item => {
            this.productOptions1.push({
              label: item.categoryName,
              value: item.id
            })
          })
        })
      }
    },

    // 产品大类选中加载小类
    productSelectOne() {
      this.productOptions1 = []
      this.loadProductOption1()
    },

    // 加载品牌
    loadBrandOption() {
      this.$http({
        url: api.snCompanyBrand.getBrandListUrl,
        method: 'post',
        data: {
          usable: 1  // 加载启用的
        }
      }).then(res => {
        this.brandOptions = []
        res.data.data.forEach(item => {
          this.brandOptions.push({
            label: item.brandName,
            value: item.id
          })
        })
      })
    },


    // 搜索
    searchEvent() {
      this.requestParam.name = this.formData.name
      this.requestParam.bigCategoryId = this.formData.bigCategoryId
      this.requestParam.smallCategoryId = this.formData.smallCategoryId
      this.requestParam.beginDate = this.formData.beginDate
      this.requestParam.endDate = this.formData.endDate
      this.requestParam.itemName = this.formData.itemName
      this.requestParam.brandId = this.formData.brandId
      this.requestParam.settleLevel = this.formData.settleLevel
      this.requestParam.siteId = this.formData.siteId
      this.requestParam.stat = this.formData.stat

      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },


    // 重置
    resetEvent() {
      this.formData = {
        bigCategoryId: '',
        smallCategoryId: '',
        name: '',
        beginDate: '',
        endDate: '',
      }

      this.requestParam.searchCount = false
      this.requestParam.current = 1
      this.requestParam.name = ''
      this.requestParam.bigCategoryId = ''
      this.requestParam.smallCategoryId = ''
      this.requestParam.beginDate = ''
      this.requestParam.endDate = ''

      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // 新增
    openEditDialog(id) {
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
    },
    // 新增
    openEditDialog2(id) {
      console.log("jjjjjjjjjjjj", id)
      this.dataId2 = 0;
      this.activeName = 'zero';
      this.$openEditView('showEdit2');
    },
    // 删除
    delect(id) {
      this.$baseConfirm('您确定要删除吗？').then(() => {
        this.$http({
          url: '/basic/sfSettleStandard/' + id,
          method: 'post'
        })
      }).then(() => {
        this.$message.success("删除成功");
        this.changeTablePage()
      }).catch(() => {
      })
    },
    editViewDataUpdate() {
      this.editViewDataUpdateFlag = true;
    },
  }
};
</script>
<style lang="scss">
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}
</style>
